import { ReactNode } from 'react'

import './index.scss'

export type AlertProps = {
  type?: 'error' | 'info' | 'success' | 'warning'
  children?: ReactNode
}

function Alert({ type = 'info', children }: AlertProps) {
  return <div className={`alert alert--${type}`}>{children}</div>
}

export default Alert
